import { observable } from 'mobx'

class ThermodynamicStore {
  @observable showErr = false
}

const store = new ThermodynamicStore()

export default store



// WEBPACK FOOTER //
// ./src/store/ThermodynamicStore.js